import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "sonner";
import { CheckCircle2, FilePlus2, ListChecks } from "lucide-react";
import { errMsg } from "../lib/api";
import { useClient } from "../context/ClientContext";
import { inr } from "../lib/format";
import { ShareBox } from "../components/po/ShareBox";

export default function POSaved() {
  const { id } = useParams();
  const { client: api, newPath, registerPath } = useClient();
  const [data, setData] = useState(null);

  useEffect(() => {
    Promise.all([api.get(`/pos/${id}`), api.get("/settings")])
      .then(([p, s]) => setData({ po: p.data, settings: s.data }))
      .catch((e) => toast.error(errMsg(e)));
  }, [id, api]);

  if (!data) return <p className="text-muted-foreground">Loading…</p>;
  const { po, settings } = data;
  return (
    <div className="space-y-5" data-testid="po-saved-page">
      <div className="panel rise flex items-start gap-3 p-5">
        <CheckCircle2 className="mt-1 shrink-0 text-brand" size={28} />
        <div className="min-w-0">
          <p className="mono-label text-muted-foreground">Saved as {po.status}</p>
          <h1 className="font-heading text-3xl font-bold tracking-tight" data-testid="saved-po-number">{po.po_no}</h1>
          <p className="text-sm text-muted-foreground">{po.vendor.name} · <span className="mono font-semibold text-foreground">{inr(po.total)}</span></p>
        </div>
      </div>
      <ShareBox po={po} settings={settings} />
      <div className={`grid gap-2 ${registerPath ? "grid-cols-2" : "grid-cols-1"}`}>
        <Link to={newPath} className="btn btn-outline" data-testid="saved-new-po-btn"><FilePlus2 size={18} /> New PO</Link>
        {registerPath && <Link to={registerPath} className="btn btn-outline" data-testid="saved-register-btn"><ListChecks size={18} /> Register</Link>}
      </div>
    </div>
  );
}
